import { RefreshCw } from "lucide-react";
import { BackupList } from "@/components/backup/BackupList";
import { BackupSchedules } from "@/components/backup/BackupSchedules";
import { RetentionConfig } from "@/components/backup/RetentionConfig";
import {
  useBackups,
  useRestoreBackup,
  useCreateBackup,
  useRetentionPolicies,
  useUpdateRetentionPolicy,
} from "@/hooks/useBackups";
import { useActiveTenant } from "@/components/tenant/TenantSelector";

export default function Backups() {
  const [tenantId] = useActiveTenant();
  const { data: backups, isLoading, refetch } = useBackups();
  const restoreBackup = useRestoreBackup();
  const createBackup = useCreateBackup();
  const { data: policies } = useRetentionPolicies(tenantId);
  const updatePolicy = useUpdateRetentionPolicy();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-100">Backups</h1>
          <p className="mt-1 text-sm text-gray-400">
            View and manage VM backups and retention policies
          </p>
        </div>
        <button
          onClick={() => refetch()}
          className="inline-flex items-center gap-2 rounded-lg border border-gray-700 px-4 py-2 text-sm font-medium text-gray-300 transition-colors hover:bg-gray-800"
        >
          <RefreshCw className="h-4 w-4" />
          Refresh
        </button>
      </div>

      <BackupList
        backups={backups ?? []}
        isLoading={isLoading}
        onRestore={(backupId) => {
          restoreBackup.mutate({ backupId });
        }}
        onCreateBackup={(vmId) => {
          createBackup.mutate({ vm_id: vmId, type: "full" });
        }}
      />

      {restoreBackup.isError && (
        <div className="rounded-xl border border-red-500/30 bg-red-500/10 p-4">
          <p className="text-sm text-red-400">
            Restore failed: {restoreBackup.error.message}
          </p>
        </div>
      )}

      <BackupSchedules />

      <RetentionConfig
        policies={policies ?? []}
        onSave={(policy) => updatePolicy.mutate(policy)}
        isSaving={updatePolicy.isPending}
      />
    </div>
  );
}
